import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query subscriptions_V2Many ($filter: FilterFindManysubscriptionsV2Input!) {
    subscriptions_V2Many (filter: $filter) {
        _id
        startDate
        endDate
        cancelDate
        frequency
        status
        amountDue
        updatedAt
        createdAt
        company {
            _id
            name
        }
        customer {
            _id
            firstName
            lastName
        }
        product {
            _id
            name
            description
            defaultPrice
        }
        pricing {
            _id
            name
            tieredPricing {
                _id
                perUnit
                firstUnit
                lastUnit
                flatFee
            }
        }
        changes {
            _id
        }
        payments {
            _id
        }
    }
}
`;
